(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/banner_layouts/card-narrow/assets/javascripts/render-component.js') >= 0) return;  svs.modules.push('/components/banner_layouts/card-narrow/assets/javascripts/render-component.js');

'use strict';

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
const isServer = typeof exports === 'object';

async function renderComponent(model, _widgetInfo, _position, req, res) {
  var _model$contentType;
  let hbsCompiled;
  let isAdmin;
  let getCallToAction;
  let features;
  const {
    callToActions,
    id: bannerId,
    images,
    layoutConfig,
    targetOffer
  } = model;
  if (isServer) {
    const trinidad = require('@svenskaspelab/trinidad-core').core;
    const hbs = global.internalInstances.get('hbs');
    hbsCompiled = hbs.cache['components-banner_layouts-card_narrow-card_narrow'];
    isAdmin = req.userSession.hasRole(req.userSession.roles.INTERNAL);
    getCallToAction = trinidad.components.require('banner_common', 'banner-helpers').getCallToAction;
    features = res.locals.features;
  } else {
    hbsCompiled = svs.banner_layouts.card_narrow.templates.card_narrow;
    isAdmin = svs.core.userSession.hasRole(svs.core.userSession.roles.INTERNAL);
    getCallToAction = svs.banner_common.banner_helpers.getCallToAction;
    features = svs.core.data.features;
  }
  const crm = targetOffer || '';
  const contentType = (model === null || model === void 0 || (_model$contentType = model.contentType) === null || _model$contentType === void 0 ? void 0 : _model$contentType.split(':').pop()) || 'banner';
  return hbsCompiled(_objectSpread(_objectSpread({}, layoutConfig), {}, {
    bannerId,
    contentType,
    callToActions: callToActions.map(cta => getCallToAction(cta)),
    crm,
    features,
    isAdmin,
    images,
    hasDocumentLink: callToActions.find(cta => cta.actionType === 'document-link')
  })) || '';
}
if (isServer) {
  module.exports = {
    renderComponent
  };
} else {
  svs.banner_layouts.card_narrow = {
    renderComponent
  };
}

 })(window);